<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import { mapMutations } from "vuex";
import axios from "@/plugins/axios.js";
import AuthService from '@/services/auth';

export default {
  name: 'App',
  async mounted() {
    const isAuthenticated = await AuthService.checkAuthentication();
    if (!isAuthenticated) {
      return;
    }
    this.checkUser();
  },
  methods : {
    ...mapMutations("auth", [
    "setUser",
    "updatePermission",
  ]),
    checkUser() {
      //this.changeValueLoading(true);      
      const token = localStorage.getItem("token");
      axios
        .post("/admin/getUser", { token: token })
        .then((response) => {
          
          this.setUser(response.data.user);
          this.updateP(response.data.user);
          //this.changeValueLoading(false);
        })
        .catch((err) => {
          this.$router.push("/login").catch(() => {});
          this.showLoadingModal = false;
          //this.changeValueLoading(false);
        });
    },
    updateP(user) {
      user.roles[0].permissions.forEach((permission) => {
        const permissionName = permission.name;
        this.updatePermission({ permission: permissionName, status: true });
      });
    },
  }
};
</script>
<style>
.pointer{
  cursor: pointer;
}
.v-main__wrap{
  background: linear-gradient(to bottom right, #2196F3, #E3F2FD);
}
</style>